"use client";

// edm內容
import { useCallback } from "react";
import "../../../styles/cryptoreadEdm.scss";

const EdmContent = ({ info }) => {
  const content = info;

  // 處理 html
  const createContent = useCallback(() => {
    String.prototype.replaceAll = function (target, payload) {
      const regex = new RegExp(target, "g");

      return this.valueOf().replace(regex, payload);
    };

    const newContent = content || "";

    return { __html: newContent };
  }, [content]);

  return (
    <div
      className="mt-[25px] edm-content"
      id="edm-content"
      dangerouslySetInnerHTML={createContent()}
    />
  );
};

export default EdmContent;
